// extracted by mini-css-extract-plugin
export default {"promoText":"XfX1K","productPromo":"Iutj6","hidden":"VXLsc","promoBox":"MEwVh","icon":"qgKez","discountCode":"BMrLg","visuallyHidden":"wmFhV"};